module.exports = __webpack_public_path__ + "static/img/complete_championscity.b9686df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/complete_championscity.png
// module id = 85OZ
// module chunks = 1